import type { ExpenseCategory } from '../api/schemas';

/** Pure helpers behind the Finanzas page: no fetching, no React. */

export const CATEGORY_LABEL: Record<ExpenseCategory, string> = {
  alquiler: 'Alquiler',
  planilla: 'Planilla',
  insumos: 'Insumos',
  servicios: 'Servicios',
  afiliacion_dale: 'Afiliación Dale',
  otro: 'Otro',
};

/** `Date` -> the 'YYYY-MM-DD' shape both the `<input type="date">` fields and the API expect. */
export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** The current calendar month as a `{from, to}` range, for the Resumen picker's default. */
export function defaultPnlRange(now: Date): { from: string; to: string } {
  const year = now.getFullYear();
  const month = now.getMonth();
  return {
    from: toDateInputValue(new Date(year, month, 1)),
    to: toDateInputValue(new Date(year, month + 1, 0)),
  };
}
